// Header.js
import React from "react";
import PropTypes from "prop-types";
import { AppBar, Button, Typography, makeStyles } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
// import AddIcon from "@material-ui/icons/Add";

const useStyles = makeStyles((theme) => ({
  header: {
    padding: theme.spacing(2,0),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: theme.palette.text.primary,
    backgroundColor: "transparent",
    boxShadow: "none",
    flexDirection: "row",
  },
  headerActions: {
    display: "flex",
    gap: theme.spacing(2),
  },
  ticketInfo: {
    display: "flex",
    alignItems: "center",
  },
  button: {

    flex: "none",
    order: 0,
    flexGrow: 0,
    background: "linear-gradient(90deg, #0A2D71 0%, #133984 100%);",
    color: "#fff",
  },
}));

const Header = ({ ticketId,  onBack }) => {
  const classes = useStyles();

  // Format the last saved timestamp for display
  // const formatLastSaved = (timestamp) => {
  //   if (!timestamp) return null;
  //   const date = new Date(timestamp);
  //   return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
  // };

  return (
    <AppBar position="static" className={classes.header}>
      <div className={classes.ticketInfo}>
        <Typography variant="h6">Ticket No: {ticketId}</Typography>
        {/* {lastSaved && (
          <Typography
            variant="body2"
            style={{ marginLeft: 16, color: "green" }}
          >
            Last saved: {formatLastSaved(lastSaved)}
          </Typography>
        )} */}
      </div>
      <div className={classes.headerActions}>
        {/* <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAddCategories}
          className={classes.button}
        >
          Add Categories
        </Button> */}
        <Button
          variant="contained"
          color="default"
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
          className={classes.button}
        >
          Back
        </Button>
      </div>
    </AppBar>
  );
};

Header.propTypes = {
  ticketId: PropTypes.string.isRequired,
  // lastSaved: PropTypes.string,
  // onAddCategories: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default Header;
